import { Component, Vue } from "vue-property-decorator";
import { gapi } from 'gapi-script';
import moment from "moment";

@Component({})
export default class Gapi extends Vue {
    debug = process.env.VUE_APP_ENVIRONMENT === "DEV" ? true : false;
    apiKey = process.env.VUE_APP_GOOGLE_API_KEY;
    clientId = process.env.VUE_APP_GOOGLE_CLIENT_ID;
    clienSecret = process.env.VUE_APP_GOOGLE_CLIENT_SECRET;
    discoveryDocs = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];
    scope = "https://www.googleapis.com/auth/calendar.readonly";
    events: [] | {};
    accessTokenG
    scopes = [
        'https://www.googleapis.com/auth/calendar.readonly'
    ];
    mounted() {
        gapi.load('client:auth2', this.initClient);
    }
    async initClient() {
        await gapi.client.init({
            apiKey: this.apiKey,
            clientId: this.clientId,
            discoveryDocs: this.discoveryDocs,
            scope: this.scopes.join(' '),
            access_type: 'offline',
        })
            .then(async (response) => {
                if (this.debug) console.log("Gapi initClient ok ", response);
            })
            .catch(async (error) => { });
    }
    async loginGoogle() {
        await gapi.auth2.getAuthInstance().currentUser.get().grantOfflineAccess({
            access_type: 'offline',
            prompt: 'consent',
            scope: this.scopes.join(' ')
        }).then(async (data) => {
            const tokenUrl = 'https://oauth2.googleapis.com/token';
            const body = await new URLSearchParams({
                code: data.code,
                client_id: this.clientId,
                client_secret: this.clienSecret,
                redirect_uri: window.location.origin,
                grant_type: 'authorization_code'
            });
            try {
                const response = await fetch(tokenUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: body.toString(),
                });
                if (!response.ok) {
                    console.log("Gapi error loginGoogle", response);
                }
                const data = await response.json();
                if (data.access_token) {
                    this.accessTokenG = await data.access_token;
                    await localStorage.setItem("gapiA", data.access_token);
                }
                if (data.refresh_token) {
                    await localStorage.setItem("gapiR", data.refresh_token);
                }
            } catch (error) {
                console.error('Gapi error loginGoogle', error);
            }
        }).catch((error) => {
            console.log('Gapi error loginGoogl', error);
        });
    }
    async refreshAccessTokenGoogle() {
        const tokenUrl = 'https://oauth2.googleapis.com/token';
        const body = await new URLSearchParams({
            client_id: this.clientId,
            client_secret: this.clienSecret,
            refresh_token: localStorage.getItem("gapiR"),
            grant_type: 'refresh_token'
        });
        try {
            const response = await fetch(tokenUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: body.toString(),
            });
            if (!response.ok) {
                console.log("Gapi error refreshAccessTokenGoogle", response);
            }
            const data = await response.json();
            if (this.debug) console.log("TTT ok refreshAccessTokenGoogle ", data);
            this.accessTokenG = data.access_token;
            localStorage.setItem("gapiA", data.access_token);
        } catch (error) {
            console.error('Gapi error refreshAccessTokenGoogle', error);
        }
    }
    async fetchCalendarEventsGoogle(accessToken) {
        await gapi.client.request({
            path: 'https://www.googleapis.com/calendar/v3/calendars/primary/events',
            method: 'GET',
            params: {
                timeMin: moment().startOf('month').toISOString(),
                singleEvents: true,
                orderBy: 'startTime',
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }).then((response) => {
            this.events = response.result.items;
        }).catch((error) => {
            console.log("Gapi fetchCalendarEvents google", error);
            if (error.status == 401)
                this.events = { code: 401 }
            else
                this.events = null;
        });
    }
    async loadGoogle(accessToken) {
        if (accessToken)
            this.accessTokenG = accessToken;
        if (!accessToken) await this.loginGoogle();
        await this.fetchCalendarEventsGoogle(this.accessTokenG);
        if (this.events && this.events["code"] == 401) {
            await this.refreshAccessTokenGoogle();
            await this.fetchCalendarEventsGoogle(this.accessTokenG);
        }
        if (this.debug) console.log("Gapi loadGoogle ", this.events);
        return this.events;
    }
    async unloadDataGoogle() {
        gapi.auth2.getAuthInstance().disconnect();
        this.accessTokenG = null;
        localStorage.removeItem("gapiA");
        localStorage.removeItem("gapiR");
        return true;
    }
}